export default __webpack_public_path__ + "static/media/affiliate-background.e1e150f2.png";